import { camelToSnake, snakeToCamel } from "caseparser";

import { api } from "@/app/app.api";

import { RequestMethod } from "@/shared/utils/RequestMethod";

export const trainingProgressesApi = api
  .enhanceEndpoints({ addTagTypes: ["trainingProgresses", "trainingProgress"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      trainingProgresses: builder.query({
        query: ({ userId, status }) => ({
          url: `progresses`,
          method: RequestMethod.GET,
          params: camelToSnake({
            userId,
            status,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["trainingProgresses"],
      }),
      trainingProgress: builder.query({
        query: ({ userId, status, id }) => ({
          url: `training-progresses/${id}`,
          method: RequestMethod.GET,
          params: camelToSnake({
            userId,
            status,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["trainingProgress"],
      }),
    }),
  });

export const { useTrainingProgressesQuery, useTrainingProgressQuery } =
  trainingProgressesApi;
